export default __webpack_public_path__ + "static/media/sb-grey.e571b0f2.svg";